export default __webpack_public_path__ + "static/media/elevate-bpn-banner-2.d5840640.jpg";